"use client";

import { useCallback, useState } from "react";

import { useAvailablePillars } from "../queries/useAvailablePillars";
import { useAviFilters } from "./useAviFilters";

interface UseAviFilterDrawerOptions {
  role: string;
}

export function useAviFilterDrawer({ role }: UseAviFilterDrawerOptions) {
  const [open, setOpen] = useState(false);
  const { data } = useAvailablePillars({ role });
  const { applyFilters, syncDraftFromApplied, resetAutoSelection, ...filters } = useAviFilters({
    role,
  });

  const handleOpenChange = useCallback(
    (nextOpen: boolean) => {
      if (nextOpen) {
        resetAutoSelection();
        syncDraftFromApplied();
      }
      setOpen(nextOpen);
    },
    [resetAutoSelection, syncDraftFromApplied]
  );

  const handleApply = useCallback(() => {
    applyFilters();
    setOpen(false);
  }, [applyFilters]);

  return {
    open,
    availablePillars: data?.available_pillars ?? [],
    handleOpenChange,
    handleApply,
    ...filters,
  };
}
